import React, { useEffect } from "react";
import { Navbar } from "@/components/Navbar";
import { TopBar } from "@/components/TopBar";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { Gallery } from "@/components/Gallery";
import { Reviews } from "@/components/Reviews";
import { About } from "@/components/About";
import { BookingForm } from "@/components/BookingForm";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { Chatbot } from "@/components/Chatbot";
import { CookieNotice } from "@/components/CookieNotice";
import { Toaster } from "@/components/ui/sonner";
import { useI18n } from "@/i18n";

export default function Home() {
  const { t, lang } = useI18n();
  useEffect(() => {
    document.title = t.meta.title;
  }, [lang, t.meta.title]);

  useEffect(() => {
    const h = window.location.hash;
    if (!h || h.length < 2) return;
    const scrollNow = () => {
      const el = document.querySelector(h);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };
    const t1 = setTimeout(scrollNow, 100);
    const t2 = setTimeout(scrollNow, 600);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  return (
    <div className="bg-white min-h-screen" data-testid="home-page">
      <TopBar />
      <Navbar />
      <main>
        <Hero />
        <Services />
        <Gallery />
        <Reviews />
        <About />
        <BookingForm />
        <Contact />
      </main>
      <Footer />
      <Chatbot />
      <CookieNotice />
      <Toaster position="top-center" richColors />
    </div>
  );
}
